import { Factory } from '@octopus-do/octopus-project-core'

import { getId } from '@/utils/temporaryHelper'
import { InitialColorIds } from '../colors'

export const initialTags = [
  Factory.tag({
    id: getId(),
    title: 'Todo',
    colorId: InitialColorIds.tag1,
  }),
  Factory.tag({
    id: getId(),
    title: 'In progress',
    colorId: InitialColorIds.tag2,
  }),
  Factory.tag({
    id: getId(),
    title: 'Done',
    colorId: InitialColorIds.header,
  }),
]
